import { Store, Module, ActionContext } from 'vuex'
import AppConsts from '@/lib/appconst'
import ListModule from './list-module'
import ListState from './list-state'
import Room from '../entities/room'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
interface RoomState extends ListState<Room> {
   
}
class RoomModule extends ListModule<RoomState, any, Room>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<Room>(),
        loading: false,
    }
    actions = {
        async getAll(context: ActionContext<RoomState, any>, payload: any) {
            context.state.loading = true;
            const {data:{result} }= await Ajax.get('/api/services/app/Room/GetAll', { params: payload.data });
            context.state.loading = false;
            const page = result as PageResult<Room>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async create(context: ActionContext<RoomState, any>, payload: any) {
            await Ajax.post('/api/services/app/Room/Create', payload.data);
        },
        async update(context: ActionContext<RoomState, any>, payload: any) {
            await Ajax.put('/api/services/app/Room/Update', payload.data);
        },
        async delete(context: ActionContext<RoomState, any>, payload: any) {
            await Ajax.delete('/api/services/app/Room/Delete?Id=' + payload.data.id);
        },
        async get(context: ActionContext<RoomState, any>, payload: any) {
            const {data:{result} } = await Ajax.get('/api/services/app/Room/Get',{ params : payload.data });
            return result;
        },
        async getRoomsForSelect(context: ActionContext<RoomState, any>, payload: any) {
            const {data:{result} } = await Ajax.get('/api/services/app/Room/GetRoomsForSelect', { params : payload.data });
            return result.items;
        }
    };
    mutations = {
        setCurrentPage(state: RoomState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: RoomState, pagesize: number) {
            state.pageSize = pagesize;
        }
    }
}
const roomModule = new RoomModule();
export default roomModule;